import React, { useEffect } from "react";
// import img1 from '../../images/stocks.svg'
import img2 from '../../images/Exposureicon.svg'
import img3 from '../../images/upper.svg'
import img1 from '../../images/aif_1.jpg'
import AOS from "aos";
import "aos/dist/aos.css";

const Offer = () => {

  useEffect(() => {
    AOS.init({
      delay: 100, // values from 0 to 3000, with step 50ms
      duration: 600, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, 
    });
  }, []);



  return (
    <>
    <div className=" mt-5" >
     <div className="container">
          <h2 className="heading text-center">Investment Philosophy</h2>
         <img src={img1} alt="Investment Philosophy" className="w-100 h-100 object-fit-cover"/>
        </div>
      </div>
  
    </>
  );
};

export default Offer;
